export default __webpack_public_path__ + "static/media/washrooms.1c7611b8.svg";